import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { TreeModule } from 'primeng/tree';
import { CustomerAffiliationEditComponent } from './customer-affiliation-edit.component';
import { CustomerAffiliationComponent } from './customer-affiliation.component';

@NgModule({
    declarations: [
        CustomerAffiliationComponent,
        CustomerAffiliationEditComponent
    ],
    providers: [
    ],
    imports: [
        CalendarModule,
        CommonModule,
        ReactiveFormsModule,
        TreeModule
    ],
    exports: [
        CustomerAffiliationComponent,
        CustomerAffiliationEditComponent
    ]
})

export class CustomerAffiliationModule {}
